module.exports = __webpack_public_path__ + "img/gj_1.20767825.jpg";